import { render, staticRenderFns } from "./QuickAddProductDetails.vue?vue&type=template&id=0b7f9b77"
import script from "./QuickAddProductDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickAddProductDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QuickAddProductDetails.vue?vue&type=style&index=0&id=0b7f9b77&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports